import { createAction, props } from '@ngrx/store';
import {
	SearchResponse,
	UserNotificationListRequest,
	UserNotificationModel,
	UserTaggedInCommentNotification
} from '@twrx-api-models';

import { ActionRequestPayload } from '../action-request-payload';
import { ActionResponsePayload } from '../action-response-payload';

export enum UserNotificationsActions {
	LoadUserNotifications = '[UserNotifications] LoadUserNotifications',
	UserNotificationsLoaded = '[UserNotifications] UserNotificationsLoaded',

	LoadUnreadCount = '[UserNotifications] LoadUnreadCount',
	UnreadCountLoaded = '[UserNotifications] UnreadCountLoaded',

	MarkRead = '[UserNotifications] MarkRead',
	MarkedRead = '[UserNotifications] MarkedRead',

	MarkAllRead = '[UserNotifications] MarkAllRead',
	MarkedAllRead = '[UserNotifications] MarkedAllRead',

	Delete = '[UserNotifications] Delete',
	Deleted = '[UserNotifications] Deleted',

	DeleteAllRead = '[UserNotifications] DeleteAllRead',
	DeletedAllRead = '[UserNotifications] DeletedAllRead',

	UserNotificationReceived = '[UserNotifications] UserNotificationReceived',

	ErrorOccurred = '[UserNotifications] ErrorOccurred'
}

export const loadUserNotifications = createAction(
	UserNotificationsActions.LoadUserNotifications,
	props<ActionRequestPayload<UserNotificationListRequest>>()
);

export const userNotificationsLoaded = createAction(
	UserNotificationsActions.UserNotificationsLoaded,
	props<ActionResponsePayload<SearchResponse<UserNotificationModel>>>()
);

export const loadUnreadCount = createAction(
	UserNotificationsActions.LoadUnreadCount,
	props<ActionRequestPayload<void>>()
);

export const unreadCountLoaded = createAction(
	UserNotificationsActions.UnreadCountLoaded,
	props<ActionResponsePayload<number>>()
);

export const markUserNotificationsRead = createAction(
	UserNotificationsActions.MarkRead,
	props<ActionRequestPayload<number[]>>()
);

export const userNotificationsMarkedRead = createAction(
	UserNotificationsActions.MarkedRead,
	props<ActionResponsePayload<number[]>>()
);

export const markAllUserNotificationsRead = createAction(
	UserNotificationsActions.MarkAllRead,
	props<ActionRequestPayload<void>>()
);

export const userNotificationsMarkedAllRead = createAction(
	UserNotificationsActions.MarkedAllRead
);

export const deleteUserNotifications = createAction(
	UserNotificationsActions.Delete,
	props<ActionRequestPayload<number>>()
);

export const userNotificationsDeleted = createAction(
	UserNotificationsActions.Deleted,
	props<ActionResponsePayload<number>>()
);

export const deleteAllReadUserNotifications = createAction(
	UserNotificationsActions.DeleteAllRead,
	props<ActionRequestPayload<void>>()
);

export const userNotificationsDeletedAllRead = createAction(
	UserNotificationsActions.DeletedAllRead
);

export const userTaggedInCommentReceived = createAction(
	UserNotificationsActions.UserNotificationReceived,
	props<ActionResponsePayload<UserTaggedInCommentNotification>>()
);
